// CORE
import React, { Component } from 'react'

// MODULES
import { 
	ModuleOne, 
	ModuleThirtyThree,
	ModuleThirtyFour,
	ModuleFive } from '../../../components/Modules'

// STYLES
import classes from '../layout.css'

class OralMaxillofacial extends Component {
	render() {
		const { addToForm, consentForm } = this.props

		return (
			<form id={consentForm.formId} className={classes.Container}>
				<h2>{consentForm.formName}</h2>

				<ModuleOne 
					addToForm={addToForm} 
					consentForm={consentForm}
				/>
				<ModuleThirtyThree 
					addToForm={addToForm} 
					consentForm={consentForm}
				/>
				<ModuleThirtyFour 
					addToForm={addToForm} 
					consentForm={consentForm}
				/>
				<p>I hereby authorize Dr. Daniel E. Esposito and staff to perform the above procedures and to administer the anesthesia. I understand the doctor may discover other or different conditions that may require additional or different procedures than those planned. I authorize him to perform such other procedures as he deems necessary, in his professional judgement, in order to complete my surgery and protect my well fare.</p>
				<p>I have read and reviewed the preceding paragraphs, and I believe I have been given sufficient information to give my informed consent to the planned surgery.</p>
				<ModuleFive 
					addToForm={addToForm} 
					consentForm={consentForm}
				/>
			</form>
		)
	}
}

export default OralMaxillofacial


// WEBPACK FOOTER //
// ./src/containers/FormLayout/Form/8.js